import { Map, List} from 'immutable';
import { actionTypes as EditAttachmentDialogActions }  from '../../../actions/Dialogs/editAttachmentDialog/editAttachmentDialogActions';

let defaultState = {
  show: false,
  assets : Map(),
  preselectedAssets: List(),
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case EditAttachmentDialogActions.EDIT_ATTACHMENT_SHOW:
      return state.set('show', true);

    case EditAttachmentDialogActions.EDIT_ATTACHMENT_HIDE:
      return Map(defaultState);

    case EditAttachmentDialogActions.EDIT_ATTACHMENT_IN_PROCESS:
      return state.set("loading", true);

    case EditAttachmentDialogActions.EDIT_ATTACHMENT_FINISHED:
      return state.set("loading", false);
    default:
      return state;
  }

}







